import React from "react";
import Breadcrumbs from "Pages/Segment/Components/Breadcrumbs";
import Container from "Components/Container/Container";
import SocialMedia from "Pages/Home/Hero/SocialMedia/SocialMedia";
import BrandSlider from "../BrandSlider/BrandSlider";
const Hero = ({ data }) => {
  return (
    <section
      style={{ backgroundImage: `url(${data?.background})` }}
      className="pt-52 pb-28 lg:pt-0 lg:pb-0  background scroll-section relative overflow-hidden"
    >
      <Container className="h-full lg:flex flex-col justify-center items-center relative ">
        <Breadcrumbs cat={"Solutions"} page={data?.name} />
        <div className="text-white text-center">
          <h1 className="text-5xl md:text-7xl lg:text-8xl bebas racking-[16px] uppercase">
            {data?.name}
          </h1>
          <div
            className="text-lg lg:text-2xl leading-[1.6]"
            dangerouslySetInnerHTML={{ __html: data?.sub_title }}
          />
        </div>
        {data && data?.brands && <BrandSlider data={data?.brands} />}
        <SocialMedia />
      </Container>
    </section>
  );
};

export default Hero;
